/**
 * Defines how the AnalyticalTable will render visible rows.
 *
 * __Note:__ When `"Auto"` is enabled, we recommend to use a fixed height for the outer container.
 */
export let AnalyticalTableVisibleRowCountMode = /*#__PURE__*/function (AnalyticalTableVisibleRowCountMode) {
  AnalyticalTableVisibleRowCountMode["Fixed"] = "Fixed";
  AnalyticalTableVisibleRowCountMode["Auto"] = "Auto";
  AnalyticalTableVisibleRowCountMode["AutoWithEmptyRows"] = "AutoWithEmptyRows";
  AnalyticalTableVisibleRowCountMode["Interactive"] = "Interactive";
  return AnalyticalTableVisibleRowCountMode;
}({});